import { useUtil } from '@/plugins/util'
import store from '@/store'
import { usePhysicianStore } from '@/store/pinia/physician'
import Vue from 'vue'
import VueRouter from 'vue-router'

import { routes } from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  const isLogged = store.getters['auth/isLogged']
  const aditionalRoutes = store.getters['auth/aditionalRoutes']
  const isAdmin = store.getters['auth/isAdmin']
  const isPrivateRoute = to.matched.some((route) => !route.meta.public)
  const isAdminOnlyRoute = to.matched.some((route) => route.meta.admin)
  const isAdminHidden = to.matched.some((route) => route.meta.hideAdmin)
  const isExtensionRequired = to.matched.some((route) => route.meta.extensionRequired)
  const accessingLoginPage = to.name === 'login'
  const accessing2FAPage = ['login-2fa', 'login-2fa-no-code'].includes(to.name)

  const pending2faToken = localStorage.getItem('kintsu-pending-2fa-token')

  if (!isLogged && isPrivateRoute) {
    next('/login')
    return
  }

  if (accessing2FAPage && (isLogged || !pending2faToken)) {
    next('/notfound')
    return
  }

  if (isLogged && isAdminOnlyRoute && !isAdmin) {
    next('/notfound')
    return
  }

  if (isLogged && isAdminHidden && isAdmin) {
    next('/notfound')
    return
  }

  if (isLogged && accessingLoginPage) {
    next({ name: 'home' })
    return
  }

  if (isExtensionRequired && !isAdmin && !aditionalRoutes.includes(to.name)) {
    next('/notfound')
    return
  }
  next()
})

router.afterEach((to) => {
  if (to.meta?.singlePage) {
    return
  }

  const util = useUtil()
  const physicianStore = usePhysicianStore()

  const analytics = util.prepareSegment()
  const userData = util.prepareSegmentUserProperties(physicianStore)
  analytics.page('Visualização de Página', {
    route: to.name,
    ...userData,
  })

  const el = document.querySelector('.content-area')
  if (el) el.scrollTop = 0
})

export default router

export function useRouter() {
  return router
}
